import type { QueryFunctionContext } from '@tanstack/react-query';
import { queryOptions } from '@tanstack/react-query';
import { apiClient } from '../../../lib/api';
import type { AdvertiserCompanyDomainRelationDTO } from './types';
import type { AdsLibraryApiPathParams } from './parseAdsLibraryApiPath';
import { parseAdsLibraryApiPath } from './parseAdsLibraryApiPath';

const getAdvertiserCompanyDomainRelations = async ({
  signal,
  queryKey,
}: QueryFunctionContext<[string, string]>): Promise<AdvertiserCompanyDomainRelationDTO[]> => {
  const res = await apiClient.get<{ data: AdvertiserCompanyDomainRelationDTO[] }>(queryKey[1], {
    signal,
  });

  return res.data.data;
};

export const getAdvertiserCompanyDomainRelationsOptions = (params: AdsLibraryApiPathParams = {}) =>
  queryOptions({
    staleTime: 60 * 60 * 1000,
    queryFn: getAdvertiserCompanyDomainRelations,
    queryKey: [
      'getAdvertiserCompanyDomainRelations',
      parseAdsLibraryApiPath('ad_advertiser_company_domain_relations', params),
    ] as const,
  });
